'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = objectToFormData;

var _metal = require('metal');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Returns a FormData containing serialized object.
 * @param {!Object} obj Object to convert to a FormData
 * @param {FormData=} formData FormData object to recursively append the serialized data
 * @param {string=} namespace Property namespace for nested objects or arrays
 * @return {FormData} FormData with the serialized object
 * @review
 */

function objectToFormData() {
	var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	var formData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new FormData();
	var namespace = arguments[2];

	Object.entries(obj).forEach(function (_ref) {
		var _ref2 = _slicedToArray(_ref, 2),
		    key = _ref2[0],
		    value = _ref2[1];

		var formKey = namespace ? namespace + '[' + key + ']' : key;

		if (Array.isArray(value)) {
			value.forEach(function (item) {
				objectToFormData(_defineProperty({}, formKey, item), formData);
			});
		} else if ((0, _metal.isObject)(value) && !(value instanceof File)) {
			objectToFormData(value, formData, formKey);
		} else {
			formData.append(formKey, value);
		}
	});

	return formData;
}